import { useCartInfo } from "@contexts/CartInfoContext";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

const BOOK_CALL_URL = "https://integratedlistening.com/contact/bookcall/";

const InvalidSkuModal: React.FC = () => {
  const { error } = useCartInfo();

  const handleScheduleCall = () => {
    window.open(BOOK_CALL_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <Dialog
      open={error !== null}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      onClose={(_event, reason) => {
        if (reason === "backdropClick") return;
      }}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle>Item Verification Error</DialogTitle>

      <DialogContent>
        <Typography variant="body1">
          We couldn't verify an item in your cart. To ensure your order is correct, please schedule
          a time with a consultant who can help you complete this purchase.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 3 }}>
        <Button
          variant="contained"
          onClick={handleScheduleCall}
          color="primary"
          sx={{ minWidth: 160 }}
        >
          Schedule a Call
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InvalidSkuModal;
